import { useEffect, useState } from "react"
import MainContentWrapper from "../../Components/MainContentWrapper"
import { LeadsCallHistoryTable } from "./leadsCallsHistory"
import { useLocation } from "react-router"
import { useSelector } from "react-redux"
import dateFormat from 'dateformat';
import { Button } from "../../Components/Helper"
import { createFollowUp, InitiateCall, sendAppLinkToUser } from "../../apis/BhuMeetTeams/Crm/leadsCallHistory"
import Popup from "../../ReusableFunctions/Popup"
import { getCallreport } from "../../apis/BhuMeetTeams/Telecaller/requestqueue"
import { AddCrmcallHistory } from "./createCrmCallHistory"
import CreateOrder from "../BhuMeetCustomerSuccess/CreateOrderPopup"
import FollowUpPopup from "./FollowUpPopup"


export const LeadsDetail = () => {

    const { state } = useLocation()
    const userDetails = useSelector(state => state.user?.user)
    const [fieldData, setFieldData] = useState([
        { label: "Created", value: state?.created },
        { label: "Email", value: state?.email },
        { label: "Phone", value: state?.phone },
        { label: "Source", value: state?.source },
        { label: "Name", value: state?.lead_name || state?.name },
        { label: "State", value: typeof (state?.location?.state) == 'object' ? '' : state?.location?.state || '' },
        { label: "District", value: typeof (state?.location?.district) == 'object' ? '' : state?.location?.district || '' },
        { label: "Taluka", value: typeof (state?.location?.taluka) == 'object' ? '' : state?.location?.taluka || '' },
        { label: "Address", value: state.address || '' }


    ])
    const [openCallhistory, setopenCallhistory] = useState(false)
    const [refresh, setrefresh] = useState(0)
    const [CallActive, setCallActive] = useState(false)
    const [campid, setCampid] = useState()
    const [sendLinkLoading, setsendLinkLoading] = useState(false);
    const [openCreateRequestPopup, setOpenCreateRequestPopup] = useState(false);
    const [loading, setLoading] = useState(true)
    const [openFollowUpPopup, setopenFollowUpPopup] = useState(false);

    const checkCallReport = async (campid) => {
        try {

            const interval = setInterval(async () => {
                const CallReport = await getCallreport()

                let findspecificCall = CallReport.filter(x => x.sid_id == campid)

                if (findspecificCall[0]?.sid_id) {
                    setCampid(findspecificCall[0].sid_id);
                    // setlastRecord(true)
                    setrefresh((prev) => prev + 1);

                    // Stop further executions as the condition is met
                    setCallActive(false)
                    setopenCallhistory(true)
                    clearInterval(interval)


                }

            }, 5000)


        } catch (err) {
            console.log(err)

        }
    }

    const formatDate = (dateStr) => {
        const date = new Date(dateStr);
        return dateFormat(date, "dd/mm/yyyy hh:MM TT");
    };

    const Field = ({ label, value, overflow, onCallClick }) => {
        const isContactNo = label === "Contact No.";
        // console.log(label,value)
        return (
            <div className="single_field_wrapper" style={{ lineHeight: overflow ? 1.15 : 1.1 }}>
                <div className='single_field_wrapper' onClick={() => {

                }} style={{ cursor: (label === "Customer Name" && userDetails.bhumeet_role != 'Telecaller') || label === "Contact No." ? "pointer" : "default", lineHeight: overflow ? 1.15 : 1.1 }}>
                    <div className='single_field_label' >{label}</div>
                    <div className='single_field_value' style={{
                        maxHeight: overflow && value?.length > 120 ? "100px" : "none",
                        overflowY: overflow && value?.length > 120 ? "auto" : "hidden"
                    }}>
                        {label == 'Phone' && userDetails.bhumeet_role == 'Telecaller Sales' ?
                            <Button style={{ whiteSpace: "nowrap", marginBottom: "5px", width: "100px" }}
                                type="submit"
                                // icon={Plus}
                                isDisabled={CallActive || state.queue_status === 'close'}
                                text={"Click to Call"}  
                                onClick={() => { onCallClick(value); }}
                            /> : label == 'Phone' ? "-" : <>
                                {label == 'Created' ? formatDate(value) : value || "-"}
                            </>}


                    </div>
                </div>
            </div>
        );
    };


    const handleFollowUp = async (selectedDate) => {
        try {
            const res = await createFollowUp({
                lead_id: state.lead_id,
                schedule_date: new Date(selectedDate).toISOString()
            })
            Popup.alert("SUCCESS", "Follow-up scheduled successfully", "SUCCESS")
            setopenFollowUpPopup(false);
        } catch (err) {
            Popup.alert("ERROR", err || "Something went wrong while add follow up ", "ERROR")
        }
    }



    const handleCall = async (toCall) => {
        try {
            setCallActive(true)
            let call = await InitiateCall(toCall, state.lead_id, userDetails.phone, state.name, 'lead')
            setCallActive(false)
            checkCallReport(call.callDetail.campid)
            Popup.alert("SUCCESS", "Call initiated Successfully", "SUCCESS")
            return

        } catch (err) {
            setCallActive(false)
            return Popup.alert("ERROR", err, "ERROR")
        }

    }

    return (
        <>

            {
                (openFollowUpPopup) &&
                <FollowUpPopup
                    open={openFollowUpPopup}
                    onClose={() => {
                        setopenFollowUpPopup(false);
                    }}
                    onRaiseFollowUp={(selectedDate) => {
                        handleFollowUp(selectedDate);
                    }}
                />
            }
            <MainContentWrapper header={"Lead Detail"} rightContent={<div>
                <div className="flex gap-6">
                    {state?.showFollowUp &&
                        <Button
                            text={"Follow Up"}
                            style={{ width: "100px" }}
                            isLoading={false}
                            type={"button"}
                            onClick={async () => {
                                setopenFollowUpPopup(true);
                            }}

                            className={"btn-large "}
                        />
                    }
                    <div className="flex gap-6">
                        {state?.showCreatedOrder &&
                            <Button
                                style={{ width: "120px" }}
                                text={"Create Order"}
                                onClick={() => {
                                    setOpenCreateRequestPopup(true);
                                }}
                                className={"btn-large "}
                            />
                        }

                        <Button
                            text={"Send App Link"}
                            style={{ width: "120px" }}
                            isDisabled={sendLinkLoading}
                            isLoading={sendLinkLoading}
                            LoadingText={"sending.."}
                            type={"button"}
                            onClick={async () => {
                                try {
                                    setsendLinkLoading(true);
                                    await sendAppLinkToUser(state?.phone);
                                    setsendLinkLoading(false);
                                    Popup.alert("SUCCESS", "App Link has sent successfully", "SUCCESS")
                                } catch (err) {
                                    setsendLinkLoading(false);
                                    Popup.alert("ERROR", "Unable to send the link to user", "ERROR");
                                }
                            }}

                            className={"btn-large "}
                        />

                    </div>

                </div>
            </div>} containerStyle={{ overflow: "auto", height: 'calc(100% - 42px)' }}>

                {openCreateRequestPopup &&
                    <CreateOrder
                        user={{ mobile_number: state?.phone, name: state?.lead_name || state?.name, state: typeof (state?.location?.state) == 'object' ? '' : state?.location?.state || '' }}
                        onuserCreate={(createdUser) => {
                            Popup.alert("SUCCESS", "User created successfully !", "SUCCESS");
                        }}
                        onClose={() => {
                            setOpenCreateRequestPopup(false);
                            setLoading(true)
                            setLoading(false);
                        }} />}

                <div style={{ height: 'calc(100% - 42px)' }}>

                    <div style={{ marginBottom: "10px", Height: "55%" }}>
                        <LeadsCallHistoryTable key={refresh} state={state} openModel={(id) => {
                            setCampid(id)
                            setopenCallhistory(true)
                        }} />

                    </div>

                    {openCallhistory &&
                        <AddCrmcallHistory open={openCallhistory} data={{ campid: campid, lead_id: state.lead_id, campaign_id: state.campaign_id }} onClose={() => { setopenCallhistory(false); setrefresh(refresh + 1) }} isEdit={true} />
                    }


                    <div style={{ marginTop: "10px", overflow: "auto", background: "white", height: "45%", width: "100%", }}>



                        <div style={{ background: "white", position: "relative", display: "flex", width: "100%" }}>
                            <div style={{ width: "100%", height: "auto", borderRight: "1px solid #8080803d" }}>
                                <div style={{ position: "relative", padding: "20px 30px", height: "auto", width: "100%", }}>
                                    <div className='request_fields_wrapper'>
                                        {fieldData.map((field, index) => (
                                            <Field key={index} label={field.label} value={field.value} overflow={field.overflow}

                                                onCallClick={async () => {
                                                    handleCall(field.value)

                                                }} />
                                        ))}
                                    </div>
                                </div>

                            </div>
                        </div>

                    </div>

                </div>

            </MainContentWrapper>
        </>
    )
}